// src/factory/buildWorkerPayload.js
import { toISODate, removeTZDateOnly } from "@utils/date";

export function buildWorkerPayload(values, plants, facilities = []) {
  const plantObj = plants.find((p) => p.value === values.plant) || {};
  const facilityObj =
    facilities.find((f) => f.value === values.facility) || {};
  const data = {
    contractor_id: values.contractorId,
    first_name: values.firstName,
    second_name: values.secondFirstName,
    third_name: values.lastName,
    fourth_name: values.secondLastName,
    email: values.email,
    city: values.city,
    state: values.state,
    street: values.streetAddress,
    zip: values.zipCode,
    country: values.country,
    phone: values.phone,
    birthdate: values.birthDate,
    drivers_license: values.driversLicense,
    bank_account: values.bankAccountNumber,
    preferred_language: values.preferredLang,
    is_w2: values.employeeType === "W2",
    is_1099: values.employeeType === "1099",
    bill_rate: values.billingRate,
    pay_rate: values.payRate,
    pay_type: values.payType,
    pay_rate_type: values.payRateClass,
    pay_rate_start_date: toISODate(values.payRateStartDate),
    billing_rate_start_date: toISODate(values.billingRateStartDate),
    billing_rate_type: values.billingRateClass,
    plant_id: plantObj.id,
    facility_id: facilityObj.id ?? null,
    start_date: removeTZDateOnly(values.firstWorkingDay),
    deductions: [],
    is_active: values.isActive,
    engagementStatus: values.engagementStatus,
    engagementStartDate: removeTZDateOnly(values.engagementStartDate),
  };

  //tax object logic here
  if (
    values.taxWithHolding != null &&
    values.taxWithHolding !== "" &&
    !isNaN(Number(values.taxWithHolding))
  ) {
    data.tax = Number(values.taxWithHolding);
  }

  const deductionMap = {
    rent: values.rentDeduction,
    admin: values.adminDeduction,
    visa_bond: values.visaBondDeduction,
    misc: values.miscDeduction,
  };

  for (const [type, amount] of Object.entries(deductionMap)) {
    if (amount) {
      data.deductions.push({
        deduction_type: type,
        amount,
      });
    }
  }

  return data;
}
